"use client";

import type { DayPickerProps } from "react-day-picker";
import { Calendar } from "@/components/ui/calendar";

export type PropertyPickerCalendarContentProps = DayPickerProps;

export function PropertyPickerCalendarContent(props: PropertyPickerCalendarContentProps) {
  return <Calendar {...props} />;
}
